export const searchFilterDebounceMs = 250;

export const glossaryTermsPerPage = 100;

export const glossarySearchItemsPerPage = 50;
